import { render, staticRenderFns } from "./MeetingRules.vue?vue&type=template&id=96991eb2&"
import script from "./MeetingRules.vue?vue&type=script&lang=js&"
export * from "./MeetingRules.vue?vue&type=script&lang=js&"
import style0 from "./MeetingRules.vue?vue&type=style&index=0&id=96991eb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports